<!-- Staff Roles Dialog - M3 Design (design.pen Node: xNL3Z) -->
<div class="confirm-dialog" [class.confirm-dialog--display-mode]="mode === Mode.disp">
  <!-- Header -->
  <div class="confirm-dialog__header">
    <div class="confirm-dialog__title">
      <div class="confirm-dialog__icon-wrapper confirm-dialog__icon-wrapper--primary">
        <mat-icon>admin_panel_settings</mat-icon>
      </div>
      <span i18n="@@adminSection.staffRoles.title.editAuthority">権限設定</span>
    </div>
    <div class="confirm-dialog__mode-badge" [class.confirm-dialog__mode-badge--edit]="mode === Mode.edit">
      @if (mode === Mode.disp) {
        <span i18n="@@adminSection.staffRoles.modeBadge.display">表示モード</span>
      } @else {
        <span i18n="@@adminSection.staffRoles.modeBadge.edit">編集モード</span>
      }
    </div>
    <button mat-icon-button class="confirm-dialog__close" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="confirm-dialog__content">
    @if (isLoading()) {
      <!-- Skeleton Loading -->
      <div class="skeleton-form">
        <!-- User Info Skeleton -->
        <div class="skeleton-user-info">
          <div class="skeleton skeleton--name"></div>
          <div class="skeleton skeleton--meta"></div>
        </div>
        <div class="skeleton skeleton--message"></div>
        <!-- Role Checkboxes Skeleton -->
        <div class="skeleton-section">
          <div class="skeleton skeleton--checkbox-item"></div>
          <div class="skeleton skeleton--checkbox-item"></div>
        </div>
      </div>
    } @else {
      <!-- Target User Info -->
      <div class="confirm-dialog__user-info">
        <div class="confirm-dialog__user-name">{{ accountData?.user?.lastName }} {{ accountData?.user?.firstName }}</div>
        <div class="confirm-dialog__user-meta" i18n="@@adminSection.staffRoles.label.staff">スタッフ</div>
      </div>

      @if (mode === Mode.edit) {
        <p class="confirm-dialog__message" i18n="@@adminSection.staffRoles.label.description">
          このスタッフに付与する管理権限を選択してください。
        </p>
      }

      <!-- Role Checkboxes -->
      <div class="role-checkboxes">
        <label class="role-checkbox" [class.role-checkbox--disabled]="mode === Mode.disp">
          <mat-checkbox [(ngModel)]="accountManageRole"
                        name="accountManageRole"
                        color="primary"
                        [disabled]="mode === Mode.disp || !validId || primaryAccount">
          </mat-checkbox>
          <div class="role-checkbox__content">
            <span class="role-checkbox__label" i18n="@@adminSection.staffRoles.label.accountManagement">スタッフ管理（登録・停止）</span>
            @if (mode === Mode.edit) {
              <span class="role-checkbox__description" i18n="@@adminSection.staffRoles.description.accountManagement">スタッフの追加・編集・停止が可能になります</span>
            }
          </div>
        </label>

        <label class="role-checkbox" [class.role-checkbox--disabled]="mode === Mode.disp">
          <mat-checkbox [(ngModel)]="userManageRole"
                        name="userManageRole"
                        color="primary"
                        [disabled]="mode === Mode.disp || !validId">
          </mat-checkbox>
          <div class="role-checkbox__content">
            <span class="role-checkbox__label" i18n="@@adminSection.staffRoles.label.userManagement">ユーザー管理（登録・停止）</span>
            @if (mode === Mode.edit) {
              <span class="role-checkbox__description" i18n="@@adminSection.staffRoles.description.userManagement">ユーザーの追加・編集・停止が可能になります</span>
            }
          </div>
        </label>
      </div>
    }
  </div>

  <!-- Footer -->
  <div class="confirm-dialog__footer">
    @if (mode === Mode.disp) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSection.staffRoles.button.close">閉じる</span>
      </button>
      <button mat-flat-button color="primary" (click)="mode = Mode.edit">
        <span i18n="@@adminSection.staffRoles.button.edit">編集</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSection.staffRoles.button.cancel">キャンセル</span>
      </button>
      <button mat-flat-button color="primary" [disabled]="isSending()" (click)="update()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        }
        <span i18n="@@adminSection.staffRoles.button.update">保存</span>
      </button>
    }
  </div>
</div>
